<template>
  <div>
    <div class="setting-nav-title">
      {{ $t("tradeTypeManage") }}
      <!-- <el-button class="confirm pull-right" @click="applyNewTrade">{{ $t("newpayment") }}</el-button> -->
    </div>
    <div style="margin-bottom: 20px;display: flex;    justify-content: space-between;">
      <el-button @click="createDialog = true">CreateTradeType</el-button>
      <el-select v-model="tenantFilter" @change="gTradeTypes()">
        <el-option value="">all</el-option>
        <el-option
          v-for="item in tenantList"
          :key="item.tenantId"
          :value="item.tenantName"
          :label="item.tenantName"
        ></el-option>
      </el-select>
    </div>
    <div class="payment-container" v-loading="loading">
      <nodata v-if="tradeTypeList.length === 0" />
      <el-table v-else :data="tradeTypeList">
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="tenant" label="tenant"></el-table-column>
        <el-table-column prop="tenantId" label="tenantId"></el-table-column>
        <el-table-column prop="paymentType" label="paymentType"></el-table-column>
        <el-table-column prop="paymentTypeId" label="paymentTypeId"></el-table-column>
        <el-table-column prop="serviceType" label="serviceType"></el-table-column>
        <el-table-column prop="tradeType" label="tradeType"></el-table-column>
        <el-table-column fixed="right" label="" width="200">
          <template slot-scope="scope">
            <el-button @click="eTradeType(scope.row)" type="text" size="small">EDIT</el-button>
            <el-button @click="dTradeType(scope.row)" type="text" size="small">DELETE</el-button>
            <el-button @click="copyTradeType(scope.row)" type="text" size="small">COPY</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="" :visible.sync="createDialog" v-loading="loading" @close="handelDialogClose" :close-on-click-modal="false">
      <el-form :model="form" ref="form">
        <el-form-item label="tenant" prop="tenant" required>
          <el-select v-model="form.tenant" style="width:100%;" @change="changeTenant">
            <el-option
              v-for="item in tenantList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.tenantName"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="form.tenant"></el-input> -->
        </el-form-item>
        <el-form-item label="tenantId" prop="tenantId" required>
          <el-input v-model="form.tenantId"></el-input>
        </el-form-item>
        <el-form-item label="paymentType" prop="paymentType" required>
          <el-input v-model="form.paymentType"></el-input>
        </el-form-item>
        <el-form-item label="paymentTypeId" prop="paymentTypeId" required>
          <el-input v-model="form.paymentTypeId"></el-input>
        </el-form-item>
        <el-form-item label="serviceType" prop="serviceType" required>
          <el-input v-model="form.serviceType"></el-input>
        </el-form-item>
        <el-form-item label="tradeType" prop="tradeType" required>
          <el-input v-model="form.tradeType"></el-input>
        </el-form-item>

        <el-form-item label="partialRefund" prop="partialRefund" required>
          <el-switch style="width:100%;" v-model="form.partialRefund"></el-switch>
        </el-form-item>
        <el-form-item label="fullRefundOnly" prop="fullRefundOnly" required>
          <el-switch style="width:100%;" v-model="form.fullRefundOnly"></el-switch>
        </el-form-item>
        <el-form-item label="refund" prop="refund" required>
          <el-switch style="width:100%;" v-model="form.refund"></el-switch>
        </el-form-item>

        <el-button @click="cTradeType()">Submit</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import paymentusing from "@/assets/using.png";
import paymentchecking from "@/assets/checking.png";
import paymentappling from "@/assets/appling.png";
import paymentfailed from "@/assets/failed.png";

import { getTradeTypes, createTradeType, delTradeType, updateTradeType } from "api/tradetype";
import { getBigPayLogoByTradeTypeName } from "utils/tradeTypeLogo";
import { getTenants, getTenantConfigType } from "api/tenant";

export default {
  data() {
    return {
      loading: false,
      createDialog: false,
      paymentusing,
      paymentchecking,
      paymentappling,
      paymentfailed,
      paylist: [],
      tenantList: [],
      tenantFilter: "netstars",
      tradeTypeList: [],
      paymentTypeList: [],
      form: {
        id: 0,
        tenantId: 0,
        tenant: "",
        tradeType: "",
        paymentTypeId: 0,
        paymentType: "",
        serviceType: "",
        partialRefund: true,
        fullRefundOnly: false,
        refund: true

        // createTime: "2023-03-15T09:29:27.543Z",
        // createBy: "string",
        // updateTime: "2023-03-15T09:29:27.543Z",
        // updateBy: "string"
      }
    };
  },
  mounted() {
    this.gTradeTypes();
    this.getList();
    // let pc = getTradeClasses().then(res => {
    //   console.log(res);
    //   if (res.statusCode == 200) {
    //     this.paymentClassList = res.result;
    //   }
    // });
    // let pt = getTradeTypes().then(res => {
    //   console.log(res);
    //   if (res.statusCode == 200) {
    //     this.paymentTypeList = res.result;
    //   }
    // });
  },
  methods: {
    changeTenant(e) {
      console.log(e);
      this.form.tenantId = this.tenantList.find(item => item.tenantName === e).id;
    },
    getList() {
      getTenants({ pageSize: 9999 }).then(res => {
        console.log(res);
        if (res.statusCode === 200 && res.resultStatus === "Success") {
          this.tenantList = res.result;
        }
      });
      // getTenantConfigType({ pageSize: 9999 }).then(res => {
      //   console.log(res);
      //   if (res.statusCode === 200 && res.resultStatus === "Success") {
      //     this.typeList = res.result;
      //   }
      // });
    },
    handelDialogClose() {
      this.form = {
        id: 0,
        tenantId: 0,
        tenant: "",
        tradeType: "",
        paymentTypeId: 0,
        paymentType: "",
        serviceType: "",
        partialRefund: true,
        fullRefundOnly: false,
        refund: true

        // createTime: "2023-03-15T09:29:27.543Z",
        // createBy: "string",
        // updateTime: "2023-03-15T09:29:27.543Z",
        // updateBy: "string"
      };
      this.$refs.form.resetFields();
    },
    gTradeTypes() {
      return getTradeTypes({ tenant: this.tenantFilter, pageSize: 9999 }).then(res => {
        console.log(res);
        if (res.statusCode == 200) {
          this.tradeTypeList = res.result;
        }
      });
    },
    cTradeType() {
      this.$refs.form.validate(valid => {
        console.log(valid);
        if (valid) {
          this.loading = true;
          let xhr;

          if (this.form.id > 0) {
            xhr = updateTradeType(this.form);
          } else {
            xhr = createTradeType(this.form);
          }

          xhr
            .then(res => {
              this.loading = false;
              console.log(res);
              if (res.statusCode == 200) {
                // this.tenantList = res.result;
                this.createDialog = false;
                this.gTradeTypes();
              }
            })
            .catch(err => {
              this.loading = false;
            });
        }
      });
    },
    dTradeType(row) {
      this.$confirm("Confirm?", "warning", {
        type: "warning"
      })
        .then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
          this.loading = true;

          delTradeType({ id: row.id })
            .then(res => {
              this.loading = false;
              console.log(res);
              if (res.statusCode == 200) {
                this.gTradeTypes().then(res => {
                  console.log(res);
                  this.loading = false;
                });
              }
            })
            .catch(err => {
              this.loading = false;
            });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    eTradeType(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.createDialog = true;
    },
    copyTradeType(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.form.id = 0;
      this.createDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.notification-container {
  margin: 16px 0;
}

.payment-container {
  background: #fffffe;
  box-shadow: 0 2px 12px 0 rgba(103, 95, 119, 0.1);
  border-radius: 8px;
  padding: 0 24px;
}

.payment-item {
  @include flex();

  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  &:last-child {
    border: none;
  }

  .payment-img-container {
    width: 122px;
    height: 80px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    position: relative;
    border-radius: 8px;

    & > img {
      width: 90px;
      height: 54px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .payment-content {
    flex: 1;
    padding: 0 30px;

    .payment-name {
      font-size: 16px;
      font-weight: 700;
      line-height: 23px;
    }

    .payment-rate {
      font-size: 12px;
    }
  }

  .payment-status {
    line-height: 24px;

    .payment-status-image {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }

    .status-text {
      font-size: 14px;
      color: #2aa76c;
      font-weight: 700;
      margin-left: 10px;
    }
  }
}
</style>
